import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import { useAuth } from "@mhj/shared/auth";
import AppShell from "./components/AppShell";
import AdminShell from "./components/AdminShell";
import LoadingScreen from "./components/LoadingScreen";
import Login from "./routes/Login";
import Register from "./routes/Register";
import VerifyEmail from "./routes/VerifyEmail";
import ActivateAccount from "./routes/ActivateAccount";
import PortalDashboard from "./routes/PortalDashboard";
import ScholarshipApply from "./routes/ScholarshipApply";
import AdminDashboard from "./routes/AdminDashboard";
import AdminProjects from "./routes/AdminProjects";
import AdminScholarships from "./routes/AdminScholarships";
import AdminScholarshipSettings from "./routes/AdminScholarshipSettings";
import AdminEmpowerment from "./routes/AdminEmpowerment";
import AdminEmpowermentCycles from "./routes/AdminEmpowermentCycles";
import AdminEmpowermentTracks from "./routes/AdminEmpowermentTracks";
import AdminCurious from "./routes/AdminCurious";
import AdminUsers from "./routes/AdminUsers";
import NotFound from "./routes/NotFound";
import AcceptedScholars from "./routes/AcceptedScholars";

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Routes>
      <Route path="/" element={<Navigate to="/portal" replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/activate-account" element={<ActivateAccount />} />
      <Route path="/scholarship-accepted" element={<AcceptedScholars />} />
      <Route path="/portal" element={<AppShell />}>
        <Route index element={<PortalDashboard />} />
        <Route path="apply" element={<ScholarshipApply />} />
      </Route>
      <Route path="/admin" element={<AdminShell />}>
        <Route
          index
          element={
            user?.role ? (
              <AdminDashboard />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route path="projects" element={<AdminProjects />} />
        <Route path="scholarships" element={<AdminScholarships />} />
        <Route path="scholarship-settings" element={<AdminScholarshipSettings />} />
        <Route path="empowerment" element={<AdminEmpowerment />} />
        <Route path="empowerment/cycles" element={<AdminEmpowermentCycles />} />
        <Route path="empowerment/tracks" element={<AdminEmpowermentTracks />} />
        <Route path="curious" element={<AdminCurious />} />
        <Route path="users" element={<AdminUsers />} />
      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
